import React from "react";
import { ColdSimulationDataCard, Footer, LeadSection, NavBar } from "../../components";
import { Box, Grid, ResponsiveLayout, skinVars, useScreenSize } from "@telefonica/mistica";
import { observer, useLocalObservable } from "mobx-react-lite";
import { redirect, useSearchParams } from "react-router-dom";
import { Store } from "./store";
import { useGlobalStore } from "../../contexts/globalStoreContext";
import { useAnalytics } from "../../hooks/useAnalytics";
import { strings } from "../../localization";
import { RMKTColdSimulation } from "../../services";
import { useNavigateCustom } from "../../hooks";

type valueType = "celular" | "email" | "nome";

const SimulatorLead: React.FC = observer(() => {
	const [urlParams] = useSearchParams();
	const store = useLocalObservable(() => new Store());
	const { preSimulationStore } = useGlobalStore();
	const navigate = useNavigateCustom();
	const { updatePageView, addAnalyticEvent } = useAnalytics();
	const [formAnalitycControl, setFormAnalitycControl] = React.useState({ cellphone: false, email: false, name: false });
	const { labelButton } = strings.components.leadSection;

	React.useEffect(() => {
		updatePageView({
			pagePath: "/fgts/simulacao-saque-aniversario",
			isNewPageviewFormat: true,
		});

		const balance = urlParams.get("balance");
		const birthMonth = urlParams.get("birthMonth");

		if (!balance || !birthMonth) {
			redirect("/");
		} else {
			preSimulationStore.balance.set(+balance);
			preSimulationStore.birthMonth.set(+birthMonth);
		}
	}, []);

	const onSubmit = (): void => {
		addAnalyticEvent(
			{
				component: "button",
				action: "click",
				description: labelButton,
				step: "lp-antecipacao-fgts",
				value: "",
			},
			{ applySanitize: true },
		);

		RMKTColdSimulation({
			balance: String(preSimulationStore.balance.value),
			birthday_month: String(preSimulationStore.birthMonth.value),
			email: store.emailInput.field.value,
			name: store.nameInput.field.value,
			phone: store.phoneInput.field.value,
		});

		navigate("/simulator-resume");
	};

	const formAnalitycTag = (valueType: valueType): void => {
		const deafultAnalitcContent = {
			component: "form",
			action: "click",
			description: `dados:${valueType}`,
			step: "lp-antecipacao-fgts",
			value: "",
		};

		switch (valueType) {
			case "celular":
				if (!formAnalitycControl.cellphone) {
					addAnalyticEvent(deafultAnalitcContent, { applySanitize: false });
					setFormAnalitycControl({ ...formAnalitycControl, cellphone: true });
				}
				break;
			case "email":
				if (!formAnalitycControl.email) {
					addAnalyticEvent(deafultAnalitcContent, { applySanitize: false });
					setFormAnalitycControl({ ...formAnalitycControl, email: true });
				}
				break;
			case "nome":
				if (!formAnalitycControl.name) {
					addAnalyticEvent(deafultAnalitcContent, { applySanitize: false });
					setFormAnalitycControl({ ...formAnalitycControl, name: true });
				}
		}
	};

	const checkboxAnalycTag = (): void => {
		addAnalyticEvent(
			{
				component: "checkbox",
				action: "click",
				description: "checkbox:politica-privacidade",
				step: "lp-antecipacao-fgts",
				value: "",
			},
			{ applySanitize: false },
		);
	};

	const { isMobile } = useScreenSize();

	return (
		<>
			<NavBar />
			<ResponsiveLayout backgroundColor={skinVars.colors.backgroundAlternative}>
				<Grid columns={{ maxSize: 700 }} justifyContent="center">
					<Box
						paddingTop={isMobile ? 32 : 40}
						paddingBottom={isMobile ? 0 : 48}
						className={"cold-simulation-card-new-layout"}
					>
						<Grid columns={{ maxSize: 600 }} justifyContent="center" gap={80}>
							<ColdSimulationDataCard
								FGTSBalance={preSimulationStore.balance.value}
								birthMonth={+preSimulationStore.birthMonth.value}
							/>
						</Grid>
						<Box className="simulator-lead-input-new-layout">
							<Grid columns={{ maxSize: 393, minSize: 327 }} justifyContent="center" gap={80}>
								<LeadSection
									email={store.emailInput.field.value}
									name={store.nameInput.field.value}
									phone={store.phoneInput.field.value}
									onEmailChange={(value) => {
										store.emailInput.onChange(value);
										formAnalitycTag("email");
									}}
									onNameChange={(value) => {
										store.nameInput.onChange(value);
										formAnalitycTag("nome");
									}}
									onPhoneChange={(value) => {
										store.phoneInput.onChange(value);
										formAnalitycTag("celular");
									}}
									onToggleCheckbox={() => {
										store.isAgreedWithTermsChecked.set(!store.isAgreedWithTermsChecked.value);
										checkboxAnalycTag();
									}}
									selectedCheckbox={store.isAgreedWithTermsChecked.value}
									onSubmit={onSubmit}
								/>
							</Grid>
						</Box>
					</Box>
				</Grid>
			</ResponsiveLayout>
			<Footer />
		</>
	);
});

export default SimulatorLead;
